var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgColumnLabels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 31.824 35.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.791,35.202H7.034c-3.878,0-7.034-3.155-7.034-7.033V7.033C0,3.155,3.155,0,7.034,0h17.757c3.878,0,7.034,3.155,7.034,7.033v21.136c0,3.878-3.155,7.033-7.034,7.033ZM7.034,2.066c-2.739,0-4.966,2.229-4.966,4.967v21.136c0,2.738,2.228,4.967,4.966,4.967h17.757c2.739,0,4.966-2.229,4.966-4.967V7.033c0-2.738-2.228-4.967-4.966-4.967H7.034Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.912,29.142c-.601,0-1.087-.486-1.087-1.087V6.842c0-.601.486-1.087,1.087-1.087s1.087.486,1.087,1.087v21.213c0,.601-.486,1.087-1.087,1.087Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.953,29.444c-1.118,0-2.235-.425-3.086-1.276l-5.441-5.441c-.425-.425-.425-1.112,0-1.537.424-.426,1.113-.426,1.537,0l5.441,5.441c.854.853,2.244.854,3.099,0l5.358-5.358c.424-.426,1.113-.426,1.537,0,.425.425.425,1.112,0,1.537l-5.358,5.358c-.851.852-1.969,1.276-3.087,1.276Z",
    fill: "currentColor"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnLabels);
export default __webpack_public_path__ + "static/media/ColumnLabels.49b37b61.svg";
export { ForwardRef as ReactComponent };